import { ExpenseStatus } from '../enums/expense-status.enum';

/**
 * Configuración visual de cada estado.
 *
 * `variant` es el modificador CSS del pill propio: no se usa `<tui-badge>`
 * porque añade un punto de color que el diseño no lleva.
 */
export interface ExpenseStatusBadge {
  labelKey: string;
  variant: 'approved' | 'returned' | 'rejected' | 'pending';
}

export const EXPENSE_STATUS_BADGE: Readonly<
  Record<ExpenseStatus, ExpenseStatusBadge>
> = {
  [ExpenseStatus.Pending]: {
    labelKey: 'expenses.status.pending',
    variant: 'pending',
  },
  [ExpenseStatus.Approved]: {
    labelKey: 'expenses.status.approved',
    variant: 'approved',
  },
  [ExpenseStatus.ReturnedToDriver]: {
    labelKey: 'expenses.status.returned_to_driver',
    variant: 'returned',
  },
  [ExpenseStatus.Rejected]: {
    labelKey: 'expenses.status.rejected',
    variant: 'rejected',
  },
};
